module.exports = __webpack_public_path__ + "img/我的报表.png";